// extracted by mini-css-extract-plugin
module.exports = {"static-page-container":"_2KXdQ3","static-page-content":"_1Gtx0L","loader":"_2-oXTQ"};